import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Chip,
    Button,
    Typography,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useNavigate } from "react-router-dom";
import { IDocumentoSetorialPagedResponse } from "models/response/documento-setorial-paged-response";
import { PaginationResponse } from "models/pagination-response";
import { getCategoryColor } from "utils/category-colors";

type DocumentosSetoriaisTableProps = {
    currentItems: PaginationResponse<IDocumentoSetorialPagedResponse>;
};

export const formatPeriodo = (indPeriodicidade: number, ano: number, periodo?: number | null): string => {
    switch (indPeriodicidade) {
        case 2: return periodo ? `${periodo}º Bimestre/${ano}` : `${ano}`;
        case 3: return periodo ? `${periodo}º Quadrimestre/${ano}` : `${ano}`;
        case 4: return `${ano}-${ano + 3}`;
        case 5: return periodo ? `${periodo}º Trimestre/${ano}` : `${ano}`;
        default: return `${ano}`;
    }
};

export const DocumentosSetoriaisTable: React.FC<DocumentosSetoriaisTableProps> = ({ currentItems }) => {
    const navigate = useNavigate();

    if (!currentItems?.hasItems()) {
        return <Typography variant="body1">Nenhum documento setorial encontrado.</Typography>;
    }

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Área</TableCell>
                        <TableCell>Tipo de Documento</TableCell>
                        <TableCell>Período</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Descrição</TableCell>
                        <TableCell align="center">Detalhes</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {currentItems.items.map((item) => (
                        <TableRow key={item.id}>
                            <TableCell>
                                <Chip label={item.areaName} size="small" style={getCategoryColor(item.areaName)} />
                            </TableCell>
                            <TableCell>{item.tipoDocumentoSetorialName}</TableCell>
                            <TableCell>{formatPeriodo(item.indPeriodicidade, item.ano, item.periodo)}</TableCell>
                            <TableCell>
                                <Chip
                                    label={item.indStatus === 2 ? 'Finalizado' : 'Em Execução'}
                                    size="small"
                                    color={item.indStatus === 2 ? 'primary' : 'default'}
                                />
                            </TableCell>
                            <TableCell>{item.textoDescricao}</TableCell>
                            <TableCell align="center">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    startIcon={<VisibilityIcon />}
                                    onClick={() => navigate(`/documentos-setoriais/${item.id}`)}
                                >
                                    Detalhes
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
